import { useRestaurant } from '@local/do-secundo-restaurant-provider'
import { FacebookPixel } from './FacebookPixel'
import React from 'react'
import useGoogleTagManager from './useGoogleTagManager'
import { GoogleAnalyticsPixel } from './GoogleAnalyticsPixel'

export const CustomTags = () => {
  const { applicableConfigs } = useRestaurant()
  const { pixelsConfig } = applicableConfigs

  useGoogleTagManager()

  return (
    <>
      {pixelsConfig?.facebook && (
        <FacebookPixel pixelId={pixelsConfig.facebook} />
      )}
      {pixelsConfig?.googleAnalytics && (
        <GoogleAnalyticsPixel trackingId={pixelsConfig.googleAnalytics} />
      )}
    </>
  )
}
